import React from "react";
import Header from "../components/Header";
import CartDrawer from "../components/CartDrawer";
import TrustBadges from "../components/TrustBadges";
import Hero from "../components/Hero";
import ReviewsStrip from "../components/ReviewsStrip";
import IntroBand from "../components/IntroBand";
import Categories from "../components/Categories";
import ShopByGoal from "../components/ShopByGoal";
import TopSellers from "../components/TopSellers";
import FeaturedProduct from "../components/FeaturedProduct";
import BestSellers from "../components/BestSellers";
import BuildGym from "../components/BuildGym";
import PackageDeals from "../components/PackageDeals";
import Blogs from "../components/Blogs";
import Showroom from "../components/Showroom";
import StorePresence from "../components/StorePresence";
import Reviews from "../components/Reviews";
import Brands from "../components/Brands";
import FAQ from "../components/FAQ";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-body">
      <Header />
      <CartDrawer />
      <main>
        <Hero />
        <ReviewsStrip />
        <TrustBadges />
        <IntroBand />
        <Categories />
        <TopSellers />
        <ShopByGoal />
        <FeaturedProduct />
        <BestSellers />
        <BuildGym />
        <PackageDeals />
        <Blogs />
        <StorePresence />
        <Showroom />
        <Reviews />
        <Brands />
        <FAQ />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
